import type { TypographyProps as MuiTypographyProps } from '@mui/material/Typography/Typography';
import MuiTypography from '@mui/material/Typography/Typography';

export type TypographyProps = MuiTypographyProps;

export const Typography = MuiTypography;
